import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";


export default function isEmail(str, responseText) {
    const regVal = regexList.email.pattern;
    return regexTest(str, regVal, responseText) || regexList.email.response;
}